"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.DeleteWRedirect = exports.Main = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var utils_1 = require("../../utils");
var Props = __importStar(require("../type"));
exports.Main = function (props) {
    return function InnerMain(innerProps) {
        var useSnackbar = props.useSnackbar, AlertDialog = props.AlertDialog, UI = props.UI, _a = props.confirmMessage, confirmMessage = _a === void 0 ? utils_1.confirmMessage : _a, _b = props.messages, messages = _b === void 0 ? Props.messagesDefault : _b, _c = props.label, label = _c === void 0 ? 'Delete' : _c;
        var promise = innerProps.promise, id = innerProps.id, onSuccess = innerProps.onSuccess, message = innerProps.message;
        var enqueueSnackbar = useSnackbar().enqueueSnackbar;
        var _d = react_1.useState(false), open = _d[0], setOpen = _d[1];
        var onClick = function () {
            setOpen(true);
        };
        var handleClose = function (mode) {
            if (mode) {
                promise(id).then(function (x) {
                    confirmMessage(enqueueSnackbar, message && message.success
                        ? message.success
                        : messages.success || Props.messagesDefault.success, 'success');
                    return onSuccess(x);
                }, function () {
                    confirmMessage(enqueueSnackbar, message && message.error
                        ? message.error
                        : messages.error || Props.messagesDefault.error, 'error');
                });
                setOpen(false);
            }
            else {
                setOpen(false);
            }
        };
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(AlertDialog, { open: open, handleClose: handleClose }),
            innerProps.UI ? (innerProps.UI({ label: label, onClick: onClick })) : (react_1["default"].createElement(UI, { label: label, onClick: onClick }))));
    };
};
exports.DeleteWRedirect = function (DeleteComponent) {
    return function InnerDeleteWRedirect(props) {
        var history = react_router_dom_1.useHistory();
        var promise = props.promise, link = props.link, id = props.id, onDelete = props.onDelete, UI = props.UI, message = props.message;
        var onSuccess = function () {
            if (onDelete) {
                onDelete();
            }
            else {
                history.push(link);
            }
        };
        return (react_1["default"].createElement(DeleteComponent, { promise: promise, id: id, onSuccess: onSuccess, message: message, UI: UI }));
    };
};
